/** Resolve account id from `?account_id=`, hash query, or mount-host `data-account-id`. */
export function getAccountIdFromUrlOrDom(routeAccountId?: unknown): string {
  const fromRoute = Array.isArray(routeAccountId)
    ? routeAccountId[0]
    : routeAccountId;
  if (typeof fromRoute === 'string' && fromRoute.trim()) {
    return fromRoute.trim();
  }

  const urlParams = new URLSearchParams(window.location.search);
  const accountIdFromUrl = urlParams.get('account_id')?.trim();
  if (accountIdFromUrl) return accountIdFromUrl;

  // Hash history embeds: `#/?account_id=...`
  const hash = window.location.hash;
  const hashQueryIndex = hash.indexOf('?');
  if (hashQueryIndex >= 0) {
    const hashParams = new URLSearchParams(hash.slice(hashQueryIndex + 1));
    const accountIdFromHash = hashParams.get('account_id')?.trim();
    if (accountIdFromHash) return accountIdFromHash;
  }

  const host =
    document.getElementById('jazel-door-app') ?? document.getElementById('app');
  const accountIdFromElement = host?.getAttribute('data-account-id')?.trim();
  if (accountIdFromElement) return accountIdFromElement;

  return '';
}

export function getJamsBackendUrl(): string {
  return String(import.meta.env.VITE_JAMS_BACKEND_URL ?? '').replace(/\/$/, '');
}

export const DOOR_PRODUCT_ID = 'door';
